import { stringify } from 'query-string';
import { BASE_URL, RESOURCE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'TEACHER_CLASSROOMS_LIST_GET_ALL',
  GET_ALL_SUCCESS: 'TEACHER_CLASSROOMS_LIST_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'TEACHER_CLASSROOMS_LIST_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(
  (query, meta) => `${BASE_URL}/${RESOURCE_URL.teacherClassroomList}?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
